import React, { useCallback, useState } from "react";
import classes from "./MobileEditPhotoModal.module.css";
import { Row, Col } from "react-bootstrap";

import ModalSkeletonCssClasses from "../../../../ModalSkeleton/ModalSkeleton.module.css";
import Colors from "../../../../../stories/assets/Colors";
import {
  CancelIconBlack,
  AddIconBlue,
  RangeSliderIcon,
  RotateIconBlue,
} from "../../../../../constant/imagePath";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import { LinkButtonWithIcon } from "../../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { Button } from "../../../../../stories/Button/Button";
import Fonts from "../../../../../stories/assets/Fonts";
import {
  ChakraProvider,
  RangeSlider,
  RangeSliderFilledTrack,
  RangeSliderThumb,
  RangeSliderTrack,
} from "@chakra-ui/react";

import Cropper from "react-easy-crop";
import getCroppedImg from "../EditPhoto/CreateImage";

export default function MobileEditPhotoModal({
  show,
  setShow,
  state,
  setter,
  onSave,
  onChangeImage,
}) {
  const [image, setImage] = useState(URL.createObjectURL(state));
  const [croppedImage, setCroppedImage] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [rotate, setRotate] = useState(0);

  const onCropComplete = useCallback(
    async (croppedArea, croppedAreaPixels) => {
      try {
        const newImage = await getCroppedImg(image, croppedAreaPixels, rotate);
        console.log("donee", { newImage });
        setCroppedImage(newImage);
      } catch (e) {
        console.error(e);
      }
    },
    [rotate]
  );

  const HandleSetRotate = () => {
    if (rotate === 270) {
      setRotate(0);
    } else {
      setRotate(rotate + 90);
    }
  };

  return (
    <>
      <style>{`
      .${ModalSkeletonCssClasses.body} {
        padding: 0px 0px;
      }
          .modal .modal-dialog {
            width: 100% !important;
            margin: 0px !important;
          }
          .modal .modal-dialog {
            max-width: 100% !important;
            height: 100%;
        }
        .modal-content{
            min-height:100%
        }
        .modal { 
            border-radius: 0px;
            background: white;
          }
        .reactEasyCrop_CropAreaGrid::before {
          border: none;
        }
        .reactEasyCrop_CropAreaGrid::after {
          border: none;
        }
        .reactEasyCrop_CropArea {
          border-radius: 16px !important;
          width: 65% !important;
          height: 93.5% !important;
          color: #222222;
          opacity: 0.8;


        }
        .rangePicker{
          margin-left:${zoom == 0 ? '24px' : '12px'} !important;
        }


    `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        borderRadius={"0px"}
        width={"100%"}
        footer={
          <div className={classes.footerBtns}>
            <LinkButtonWithIcon
              text={"Change image"}
              primary={false}
              customStyle={{ color: Colors.neutralShadesOfNero }}
              onClick={() => setShow(false)}
            />
            <Button
              label={"Save"}
              primary={true}
              customStyle={{
                padding: "12px 32px",
                height: "56px",
                maxWidth: "156px",
              }}
              onClick={() => {
                onSave(croppedImage);
                setShow(false);
              }}
            />
          </div>
        }
      >
        <div className={classes.modalContent}>

          <Col md={12} className={classes?.HeaderContainer} style={{ borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro} ` }}>
            <img
              src={CancelIconBlack}
              className={classes?.closeIcon}
              onClick={() => setShow(false)}
            />
            <span className={classes?.headingText} style={{ ...Fonts?.b3 }}>
              Edit Photo
            </span>
          </Col>
          <Col md={12}>
            <div className={classes.imageBox}>
              <div className="crop-container">
                <Cropper
                  image={image}
                  crop={crop}
                  zoom={zoom}
                  rotation={rotate}
                  aspect={4 / 3}
                  onCropChange={setCrop}
                  onCropComplete={onCropComplete}
                  onZoomChange={setZoom}
                  style={{ containerStyle: { maxHeight: "400px" } }}
                />
              </div>
              <div className={classes.rangeWithBtns}>
                <span style={{
                  marginRight: zoom == 1 ? '12px' : '0px'
                }}>                <LinkButtonWithIcon
                    leftIcon={AddIconBlue}
                    text={"Zoom"}
                    primary={true}
                    customStyle={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "space-between",
                      ...Fonts.otherMedium,


                    }}
                    iconStyle={{ margin: "0px" }}
                    disabled={zoom == 1 ? true : false}
                    onClick={() => setZoom((prev) => ++prev)}
                  />
                </span>

                <ChakraProvider>
                  <div className={`${[classes.rangePicker].join(" ")}`}>
                    <RangeSlider
                      aria-label={["min", "max"]}
                      onChange={(e) => {
                        setZoom(e[0]);
                      }}
                      value={[zoom, 1.5]}
                      min={1}
                      max={1.5}
                      step={0.05}
                    >
                      <RangeSliderTrack bg={Colors.neutralShadesOfWhisper}>
                        <RangeSliderFilledTrack
                          bg={Colors.neutralShadesOfGainsboro}
                        />
                      </RangeSliderTrack>

                      <RangeSliderThumb
                        boxSize={6}
                        index={0}
                        style={{
                          backgroundColor: "none",
                          background: `url(${RangeSliderIcon})`,
                          border: "none",
                          borderRadius: 0,
                          display: "flex",
                          boxShadow: "none",
                        }}
                      ></RangeSliderThumb>
                      <RangeSliderThumb
                        boxSize={6}
                        index={1}
                        style={{
                          backgroundColor: "none",
                          background: `url(${RangeSliderIcon})`,
                          border: "none",
                          borderRadius: 0,
                          display: "none",
                        }}
                      ></RangeSliderThumb>
                    </RangeSlider>
                  </div>
                </ChakraProvider>
                <span>
                  <LinkButtonWithIcon
                    leftIcon={RotateIconBlue}
                    text={"Rotate"}
                    primary={true}
                    customStyle={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "space-between",
                      ...Fonts.otherMedium
                    }}
                    iconStyle={{
                      margin: "0px",
                    }}
                    onClick={() => {
                      HandleSetRotate();
                    }}
                  />
                </span>
              </div>
            </div>
          </Col>
          <Col sm={12} className={classes.texts}>
            <p style={{ ...Fonts.h9, color: Colors.neutralShadesOfNero }}>
              Must be an actual photo of you.
            </p>
            <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}>
              Logos, clip-art, group photos, and digitally-altered images are
              not allowed
            </p>
          </Col>
        </div>
      </ModalSkeleton>
    </>
  );
}
